<span class="badge badge-pedido-status badge-pedido-status-cancelado">
    {{status.nome}}
</span>